/** biome-ignore-all lint/correctness/useUniqueElementIds: unique img id */
import { Outlet } from 'react-router-dom';

import { FaqSection } from '@/components/FaqSection/FaqSection';
import { useFaq } from '@/components/FaqSection/useFaq';
import { PageFooter } from '@/components/PageFooter/PageFooter';

import './styles.scss';

export default function UnauthenticatedLayout() {
  const { showFaq, openFaq, closeFaq } = useFaq();
  return (
    <div className="unauthenticatedLayout">
      <main className="unauthenticatedLayout__main">
        {!showFaq && (
          <div className="unauthenticatedLayout__logoContainer">
            <img alt="sonataLogo" id="sonataLogo" src="/assets/images/logos/logoSonataV2.png" />
          </div>
        )}
        <section
          className={`unauthenticatedLayout__mainContent${showFaq ? ' unauthenticatedLayout__mainContent--faq' : ''}`}
        >
          {showFaq ? <FaqSection onClose={closeFaq} /> : <Outlet />}
        </section>
      </main>
      <PageFooter onFaqOpen={openFaq} />
    </div>
  );
}
